// Référentiels des diplômes VAE

export const PROGRAM_REFERENTIALS = {
  'cap-aepe': {
    description: "Le CAP Accompagnant Éducatif Petite Enfance est le premier niveau de qualification du secteur de la petite enfance. Le titulaire de ce diplôme est un professionnel qualifié compétent pour l'accueil et la garde des jeunes enfants.",
    objectives: [
      "Accompagner l'enfant dans ses découvertes et ses apprentissages",
      "Prendre soin et accompagner l'enfant dans les activités de la vie quotidienne",
      "Inscrire son action dans le réseau des relations enfants-parents-professionnels"
    ],
    competences: [
      {
        bloc: "EP1 - Accompagner le développement du jeune enfant",
        competences: [
          "Accompagner l'enfant dans ses découvertes et ses apprentissages",
          "Mettre en œuvre des activités d'éveil en tenant compte de la singularité de l'enfant",
          "Réaliser des soins du quotidien et accompagner l'enfant dans ses apprentissages",
          "Appliquer des protocoles liés à la santé de l'enfant"
        ]
      },
      {
        bloc: "EP2 - Exercer son activité en accueil collectif",
        competences: [
          "Coopérer avec l'ensemble des acteurs concernés",
          "Établir une relation privilégiée et sécurisante avec l'enfant",
          "Assurer une assistance pédagogique au personnel enseignant",
          "Assurer des activités de remise en état des matériels et locaux"
        ]
      },
      {
        bloc: "EP3 - Exercer son activité en accueil individuel",
        competences: [
          "Organiser son action",
          "Négocier le cadre de l'accueil",
          "Assurer les opérations d'entretien du logement et des espaces réservés à l'enfant",
          "Élaborer des repas"
        ]
      }
    ],
    debouches: [
      "Agent de crèche",
      "Auxiliaire de crèche",
      "Agent d'animation",
      "Garde d'enfants à domicile",
      "Assistant maternel"
    ]
  },
  'deap': {
    description: "Le Diplôme d'État d'Auxiliaire de Puériculture forme des professionnels qualifiés pour réaliser des activités d'éveil et d'éducation et dispenser des soins d'hygiène et de confort pour préserver et restaurer la continuité de la vie, le bien-être et l'autonomie de l'enfant.",
    objectives: [
      "Accompagner l'enfant dans les activités de sa vie quotidienne et sociale",
      "Collaborer au projet de soins personnalisé dans son champ de compétences",
      "Contribuer à la prévention des risques et au raisonnement clinique interprofessionnel"
    ],
    competences: [
      {
        bloc: "Bloc 1 - Accompagnement et soins de l'enfant",
        competences: [
          "Accompagner l'enfant et son entourage dans les actes essentiels de la vie quotidienne",
          "Apprécier l'état clinique d'un enfant à tout âge",
          "Réaliser des soins adaptés à l'état clinique de l'enfant",
          "Utiliser les techniques préventives de manutention"
        ]
      },
      {
        bloc: "Bloc 2 - Évaluation de l'état clinique",
        competences: [
          "Observer l'enfant et mesurer les principaux paramètres",
          "Identifier les signes de détresse et de douleur",
          "Discerner le caractère urgent d'une situation",
          "Accompagner l'enfant dans la réalisation des soins"
        ]
      },
      {
        bloc: "Bloc 3 - Information et accompagnement des personnes",
        competences: [
          "Rechercher, traiter et transmettre les informations",
          "Organiser son activité et coordonner son action",
          "Informer et former les pairs, les personnes en formation",
          "Accueillir et accompagner les familles et l'entourage"
        ]
      },
      {
        bloc: "Bloc 4 - Entretien de l'environnement immédiat",
        competences: [
          "Utiliser les techniques d'entretien des locaux",
          "Respecter les protocoles d'hygiène",
          "Identifier les risques liés à l'hygiène",
          "Contrôler et gérer les stocks"
        ]
      },
      {
        bloc: "Bloc 5 - Travail en équipe pluri-professionnelle",
        competences: [
          "Organiser son activité au sein d'une équipe",
          "Collaborer et coopérer au sein d'une équipe",
          "Développer une communication adaptée",
          "Accueillir et accompagner les stagiaires"
        ]
      }
    ],
    debouches: [
      "Maternité",
      "Service de néonatologie et pédiatrie",
      "Établissement d'accueil du jeune enfant",
      "Service de Protection Maternelle et Infantile (PMI)",
      "Structure d'aide sociale à l'enfance"
    ]
  },
  'deeje': {
    description: "Le Diplôme d'État d'Éducateur de Jeunes Enfants forme des professionnels de l'accompagnement et de l'éducation des enfants de 0 à 7 ans. L'éducateur favorise le développement global et harmonieux des enfants en stimulant leurs potentialités intellectuelles, affectives, artistiques.",
    objectives: [
      "Favoriser le développement et l'épanouissement des jeunes enfants",
      "Concevoir et conduire un projet éducatif adapté",
      "Travailler en équipe pluridisciplinaire et en partenariat"
    ],
    competences: [
      {
        bloc: "DC1 - Accueil et accompagnement du jeune enfant",
        competences: [
          "Accueillir et accompagner le jeune enfant et sa famille",
          "Elaborer et mettre en œuvre le projet éducatif",
          "Concevoir et animer des activités éducatives",
          "Créer et aménager des espaces propices au développement"
        ]
      },
      {
        bloc: "DC2 - Action éducative en direction du jeune enfant",
        competences: [
          "Observer et analyser les situations éducatives",
          "Concevoir un projet éducatif et social adapté",
          "Mettre en œuvre des actions éducatives",
          "Évaluer les actions et le projet éducatif"
        ]
      },
      {
        bloc: "DC3 - Communication professionnelle",
        competences: [
          "Travailler en équipe pluridisciplinaire",
          "Communiquer et informer les parents",
          "Développer des partenariats institutionnels",
          "Coordonner et animer une équipe"
        ]
      },
      {
        bloc: "DC4 - Dynamiques institutionnelles et partenariales",
        competences: [
          "Établir une relation de confiance avec les partenaires",
          "S'inscrire dans un travail d'équipe et de réseau",
          "Contribuer à l'élaboration du projet d'établissement",
          "Participer à la veille professionnelle"
        ]
      }
    ],
    debouches: [
      "Crèches collectives",
      "Haltes-garderies",
      "Jardins d'enfants",
      "Centres de loisirs",
      "Hôpitaux"
    ]
  },
  'caferuis': {
    description: "Le Certificat d'Aptitude aux Fonctions d'Encadrement et de Responsable d'Unité d'Intervention Sociale forme des cadres intermédiaires du secteur social et médico-social. Le titulaire encadre des équipes et met en œuvre des projets d'action sociale.",
    objectives: [
      "Piloter une unité d'intervention sociale",
      "Manager une équipe et conduire l'action",
      "Gérer les ressources humaines, financières et logistiques"
    ],
    competences: [
      {
        bloc: "DF1 - Conception et conduite de projets",
        competences: [
          "Analyser les caractéristiques d'une unité d'intervention sociale",
          "Élaborer et conduire un projet d'unité ou de service",
          "Évaluer le projet et ses effets",
          "Adapter le projet aux évolutions du contexte"
        ]
      },
      {
        bloc: "DF2 - Expertise technique",
        competences: [
          "Développer une expertise technique",
          "Veiller à la qualité des prestations",
          "Mettre en œuvre des démarches d'amélioration continue",
          "Garantir la conformité aux référentiels"
        ]
      },
      {
        bloc: "DF3 - Management d'équipe",
        competences: [
          "Animer et conduire une équipe",
          "Organiser le travail et déléguer",
          "Gérer les conflits et réguler les tensions",
          "Évaluer les pratiques professionnelles"
        ]
      },
      {
        bloc: "DF4 - Gestion administrative et budgétaire",
        competences: [
          "Élaborer et suivre un budget",
          "Gérer les ressources humaines",
          "Assurer une gestion administrative",
          "Mettre en place des tableaux de bord"
        ]
      },
      {
        bloc: "DF5 - Communication et partenariats",
        competences: [
          "Communiquer en interne et en externe",
          "Développer des partenariats",
          "Représenter l'unité dans les instances",
          "Promouvoir les actions de l'unité"
        ]
      }
    ],
    debouches: [
      "Chef de service en établissement social ou médico-social",
      "Responsable d'unité d'intervention sociale",
      "Coordinateur de services",
      "Responsable de secteur",
      "Adjoint de direction"
    ]
  },
  'tp': {
    description: "Le Titre Professionnel permet de certifier des compétences professionnelles acquises par l'expérience. Il atteste que son titulaire maîtrise les compétences, aptitudes et connaissances permettant l'exercice d'un métier.",
    objectives: [
      "Valider les compétences acquises par l'expérience",
      "Obtenir une certification professionnelle reconnue",
      "Faciliter l'évolution professionnelle et la mobilité"
    ],
    competences: [
      {
        bloc: "Compétences professionnelles",
        competences: [
          "Maîtriser les techniques et gestes professionnels du métier",
          "Respecter les règles d'hygiène et de sécurité",
          "Organiser son activité professionnelle",
          "Communiquer dans un contexte professionnel"
        ]
      },
      {
        bloc: "Compétences transversales",
        competences: [
          "S'adapter aux évolutions techniques et organisationnelles",
          "Travailler en équipe et en autonomie",
          "Résoudre des problèmes professionnels",
          "Rendre compte de son activité"
        ]
      }
    ],
    debouches: [
      "Variable selon le titre professionnel visé",
      "Évolution dans le secteur d'activité concerné",
      "Mobilité professionnelle facilitée",
      "Reconnaissance des compétences"
    ]
  },
  'bac-assp': {
    description: "Le Baccalauréat Professionnel Accompagnement, Soins et Services à la Personne forme des professionnels compétents pour assurer le bien-être et le confort des personnes (enfants, personnes âgées, personnes en situation de handicap) en structures collectives ou à domicile.",
    objectives: [
      "Assurer des activités de soins d'hygiène et de confort",
      "Maintenir et restaurer l'autonomie des personnes",
      "Créer et maintenir un lien social avec les personnes accompagnées"
    ],
    competences: [
      {
        bloc: "Ergonomie-Soins",
        competences: [
          "Dispenser des soins d'hygiène corporelle, de confort et de sécurité",
          "Réaliser des activités liées à l'hygiène et au confort de l'environnement de la personne",
          "Concevoir et mettre en œuvre des activités d'acquisition ou de maintien de l'autonomie",
          "Surveiller l'état de santé de la personne et intervenir en conséquence"
        ]
      },
      {
        bloc: "Animation-Education à la santé",
        competences: [
          "Mettre en œuvre des activités d'éveil, de maintien du lien social",
          "Conduire des actions d'éducation à la santé",
          "Organiser des activités adaptées aux besoins et capacités",
          "Évaluer les effets des actions mises en œuvre"
        ]
      },
      {
        bloc: "Communication professionnelle et travail en équipe",
        competences: [
          "Accueillir, communiquer avec la personne et son entourage",
          "Transmettre des informations",
          "S'inscrire dans un travail d'équipe et en réseau",
          "Organiser son travail au sein d'une équipe pluri-professionnelle"
        ]
      }
    ],
    debouches: [
      "Aide-soignant en établissement de santé",
      "Accompagnant éducatif et social",
      "Auxiliaire de vie sociale",
      "Agent de service hospitalier",
      "Assistant de soins en gérontologie"
    ]
  },
  'deas': {
    description: "Le Diplôme d'État d'Aide-Soignant forme des professionnels qui dispensent des soins d'hygiène et de confort aux patients. L'aide-soignant veille à leur bien-être et les accompagne dans tous les gestes de la vie quotidienne.",
    objectives: [
      "Accompagner la personne dans les actes essentiels de la vie quotidienne",
      "Apprécier l'état clinique d'une personne et réaliser des soins adaptés",
      "Travailler en équipe pluri-professionnelle et informer les personnes"
    ],
    competences: [
      {
        bloc: "Bloc 1 - Accompagnement et soins de la personne",
        competences: [
          "Accompagner les personnes dans les actes essentiels de la vie quotidienne et de la vie sociale",
          "Identifier les situations à risque lors de l'accompagnement",
          "Utiliser les techniques préventives de manutention",
          "Établir une communication adaptée pour informer et accompagner"
        ]
      },
      {
        bloc: "Bloc 2 - Évaluation de l'état clinique",
        competences: [
          "Observer la personne et mesurer les principaux paramètres liés à son état de santé",
          "Apprécier les changements dans l'état de santé",
          "Identifier les signes permettant d'apprécier les effets de l'évolution de l'état de santé",
          "Discerner le caractère urgent d'une situation pour alerter"
        ]
      },
      {
        bloc: "Bloc 3 - Soins",
        competences: [
          "Rechercher et traiter les informations pour assurer la continuité des soins",
          "Organiser son activité au sein d'une équipe pluri-professionnelle",
          "Réaliser des soins d'hygiène et de confort",
          "Collaborer à la réalisation de soins techniques"
        ]
      },
      {
        bloc: "Bloc 4 - Ergonomie",
        competences: [
          "Utiliser des techniques d'entretien des locaux et du matériel",
          "Repérer et traiter les anomalies et dysfonctionnements",
          "Respecter les protocoles d'hygiène et de sécurité",
          "Éliminer les déchets selon les protocoles"
        ]
      },
      {
        bloc: "Bloc 5 - Communication et vie institutionnelle",
        competences: [
          "Rechercher, traiter et transmettre les informations",
          "S'exprimer au sein d'une équipe pluri-professionnelle",
          "Accueillir et accompagner les stagiaires en formation",
          "Respecter les règles et valeurs de la profession"
        ]
      }
    ],
    debouches: [
      "Hôpitaux et cliniques",
      "EHPAD et maisons de retraite",
      "Services de soins à domicile",
      "Centres de rééducation",
      "Établissements médico-sociaux"
    ]
  }
};
